import type { DeviceStatus } from '@eon/types';
import { Badge } from './badge';

type Variant = 'success' | 'info' | 'warning' | 'destructive' | 'secondary' | 'default';

const map: Record<DeviceStatus, { variant: Variant; label: string }> = {
  available: { variant: 'success', label: 'Available' },
  preparing: { variant: 'info', label: 'Preparing' },
  charging: { variant: 'info', label: 'Charging' },
  suspended_ev: { variant: 'warning', label: 'Suspended (EV)' },
  suspended_evse: { variant: 'warning', label: 'Suspended (EVSE)' },
  finishing: { variant: 'info', label: 'Finishing' },
  reserved: { variant: 'info', label: 'Reserved' },
  unavailable: { variant: 'secondary', label: 'Unavailable' },
  faulted: { variant: 'destructive', label: 'Faulted' },
  offline: { variant: 'secondary', label: 'Offline' },
  unknown: { variant: 'secondary', label: 'Unknown' },
};

export function StatusPill({ status, label }: { status: DeviceStatus; label?: string }) {
  const m = map[status] ?? { variant: 'secondary' as Variant, label: 'Unknown' };
  return <Badge variant={m.variant}>{label ?? m.label}</Badge>;
}
